module.exports = __webpack_public_path__ + "media/images/apple-pay-LogoSvg-e797eb701c1a5da799f07a804473dd81.png";